import PicksGrupo from './PicksGrupo';
export default PicksGrupo;
